import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconVoteStyle0 = cosmosIconCss;

const CosmosIconVote$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconVote extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'd8bdd18833b468d7c59f6078c3fb1aaf223c5417', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '22891554250fb9d752ee29b5208daf1075be19a3', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6aae982d9a0342ada52a934af1d44a42e23bc994', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M5.37 2c-.354 0-.765.039-1.083.068l-.017.002L2.1 7.24a1.291 1.291 0 0 0-.1.52v3.7c0 .158.069.308.19.41 1.18.87 2.55 1.11 6.44 1.13a.537.537 0 0 0 .4-.18C10.6 10.78 11 9.81 11 8.06a7.33 7.33 0 0 0-.32-2.17.447.447 0 0 0-.5-.3l-2.82.34.34-1.43c.069-.258.106-.523.11-.79C7.81 2.59 6.97 2 5.37 2Zm-.08 1.5c.344-.023.688.028 1.01.15v.06l.001.048c-.002.084-.021.167-.148.704l-.063.268-.53 2.25a.5.5 0 0 0 .55.61l3.33-.4c.04.41.06.64.06.87a4.884 4.884 0 0 1-1.35 3.44c-2.43 0-3.78-.17-4.65-.59v-3.1L5.29 3.5ZM16.63 20c.354 0 .765-.039 1.083-.068l.017-.002 2.17-5.17c.069-.165.103-.342.1-.52v-3.7a.533.533 0 0 0-.19-.41c-1.18-.87-2.55-1.11-6.44-1.13a.537.537 0 0 0-.4.18C11.4 11.22 11 12.19 11 13.94a7.323 7.323 0 0 0 .32 2.17c.07.21.282.337.5.3l2.82-.34-.34 1.43a3.259 3.259 0 0 0-.11.79c0 1.12.84 1.71 2.44 1.71Zm.08-1.5a2.385 2.385 0 0 1-1.01-.15v-.06l-.001-.048c.002-.084.021-.167.148-.704l.063-.268.53-2.25a.5.5 0 0 0-.55-.61l-3.33.4a8.99 8.99 0 0 1-.06-.87 4.884 4.884 0 0 1 1.35-3.44c2.43 0 3.78.17 4.65.59v3.1l-1.79 4.31Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconVoteStyle0; }
}, [1, "cosmos-icon-vote", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-vote"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-vote":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconVote$1);
            }
            break;
    } });
}

const CosmosIconVote = CosmosIconVote$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconVote, defineCustomElement };
